export default [
  {
    money: 1000000, // 1 million money
    animals: ['Bambini Crostini', 'Alessio'],
    luckMultiplier: 1.5, // +50% Luck
    moneyMultiplier: 1.5, // +50% Money
    weaponDamage: 10,
    farmCols: 3,
    rewards: [
      { icon: 'luck', description: '+50% Luck' },
      { icon: 'cash', description: '+50% Money' },
      { icon: 'upgrade', description: 'Bigger Island' },
    ],
  },
  {
    money: 50000000, // 50 million money
    animals: ['Bananita Dolphinita', 'Ballerina Cappuccina'],
    luckMultiplier: 1.5, // +50% Luck
    moneyMultiplier: 1.5, // +50% Money
    weaponDamage: 20,
    farmCols: 4,
    rewards: [
      { icon: 'luck', description: '+50% Luck' },
      { icon: 'cash', description: '+50% Money' },
      { icon: 'upgrade', description: 'Bigger Island' },
    ],
  },
  {
    money: 100000000, // 100 million money
    animals: ['Glorbo Fruttodrillo', 'Bombombini Gusini'],
    luckMultiplier: 1.5, // +50% Luck
    moneyMultiplier: 1.5, // +50% Money
    weaponDamage: 30,
    rewards: [
      { icon: 'luck', description: '+50% Luck' },
      { icon: 'cash', description: '+50% Money' },
    ],
  },
  {
    money: 150000000,
    animals: ['Glorbo Fruttodrillo', 'Los Tralaleritos'],
    luckMultiplier: 1.5, // +50% Luck
    moneyMultiplier: 1.5, // +50% Money
    weaponDamage: 40,
    rewards: [
      { icon: 'luck', description: '+50% Luck' },
      { icon: 'cash', description: '+50% Money' },
    ],
  },
  {
    money: 300000000,
    animals: ['Tralalero Tralala', 'Girafa Celestre'],
    luckMultiplier: 1.5, // +50% Luck
    moneyMultiplier: 1.5, // +50% Money
    weaponDamage: 40,
    rewards: [
      { icon: 'luck', description: '+50% Luck' },
      { icon: 'cash', description: '+50% Money' },
    ],
  },
]
